import * as React from "react";
import styled, { css } from "../../../styled/index";
import { RestaurantIcon, RestaurantIconList, RestaurantIcons } from "../../elements/restaurant.icon/index";
import cn from "classnames";
import {CS} from "../../../styles/index";

const Wrapper = styled("div")`
  display: flex;
  flex-wrap: wrap;
`;

const Icon = styled("div")`
  ${CS.flex.center};
  width: 50px;
  height: 50px;
  border: 1px solid ${({theme}) => theme.input.border};
  cursor: pointer;
  font-size: 32px;
  &:hover, &.active {
    background: ${({theme}) => theme.colors.primary};
    color: ${({theme}) => theme.colors.primary_text};
  }
`;

interface Props {
  selected?: RestaurantIcons;
  onChange: (icon: RestaurantIcons) => void;
}

export const RestaurantIconSelect = (props: Props) => (
  <Wrapper>
    {Object.keys(RestaurantIconList).map((key) => (
      <Icon
        key={key}
        onClick={() => props.onChange(key as RestaurantIcons)}
        className={props.selected === key ? "active" : ""}>
        <RestaurantIcon icon={key as RestaurantIcons}/>
      </Icon>
    ))}
  </Wrapper>
);
